export const routes = {
  home: "/",
  payment: "/payment",
  register: "/register",
  login: "/login",
  forgetPassword: "/forgotPassword",
  resetPassword: "/resetPassword",
  changePassword: "/changePassword",
  confirm: "/confirm",
  aboutUs: "/aboutus",
  settings: "/settings",
  company: "/company",
  createCompany: "/create-company",
  quatation: "/quatation",
  profile: "/profile",
  createTender: "/create-tender",
  tender: "/tender",
  info: "/info",
  quatationtenders: "/Quatationtenders",
  tenderSquatenders: "/TenderSquatenders",
  tenders: "/tenders",
  orders: "/orders",
  checkout: "/checkout",
  vuetender: "/vuetender",
  articles: "/articles",
  items: "/items",
  order: "/order",
  payLater: "/payLater",
};
